module.exports = __webpack_public_path__ + "img/apple-pay.913c2f37.png";